import userRoutes from './user'
import servicesRoutes from './services'
import attachmentRoutes from './attachments'
import administrationRoutes from './administration'
import routingRoutes from './routing'
import securityRoutes from './security'
import globalRoutes from './global'

export default [
  ...attachmentRoutes,
  ...servicesRoutes,
  ...userRoutes,
  ...administrationRoutes,
  ...routingRoutes,
  ...securityRoutes,
  ...globalRoutes
]
